import { Component, DestroyRef, OnDestroy, OnInit, inject, signal, computed } from '@angular/core';
import { FaultyVehicleDataService, VehicleDataFieldEnum } from '../../service/FaultyVehicleData.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {debounceTime, Subject} from 'rxjs';
import { fadeInAnimation } from '../../animations/fadeInAnimation';

@Component({
  selector: 'app-faulty-vehicle-data',
  templateUrl: './faulty-vehicle-data.component.html',
  styleUrls: ['./faulty-vehicle-data.component.css'],
  animations: [fadeInAnimation],
  host: { '[@fadeInAnimation]': '' }
})
export class FaultyVehicleDataComponent implements OnInit, OnDestroy {

  public faultyVehicleDataService = inject(FaultyVehicleDataService);
  public selectedFaultyValue = this.faultyVehicleDataService.selectedFaultyValue;
  readonly searchInput = signal('');
  private searchChanges = new Subject<string | null>();
  private destroyRef = inject(DestroyRef);

  public vehicleDataFields = [
    VehicleDataFieldEnum.ECU_BUILD,
    VehicleDataFieldEnum.VEHICLE_PRODUCER,
    VehicleDataFieldEnum.VEHICLE_TYPE,
    VehicleDataFieldEnum.ECU_PRODUCER,
  ];

  public fieldLabels = {
    [VehicleDataFieldEnum.ECU_BUILD]: 'ECU Build',
    [VehicleDataFieldEnum.VEHICLE_PRODUCER]: 'Vehicle Producer',
    [VehicleDataFieldEnum.VEHICLE_TYPE]: 'Vehicle Type',
    [VehicleDataFieldEnum.ECU_PRODUCER]: 'ECU Producer',
  };

  public searchPlaceholder = computed(() =>
      'Faulty ' + this.getFieldLabel(this.faultyVehicleDataService.selectedField())
  );

  readonly selectionTitle = computed(() => ({
    [VehicleDataFieldEnum.ECU_BUILD]: 'Select an ECU build',
    [VehicleDataFieldEnum.VEHICLE_PRODUCER]: 'Select a vehicle producer',
    [VehicleDataFieldEnum.VEHICLE_TYPE]: 'Select a vehicle type',
    [VehicleDataFieldEnum.ECU_PRODUCER]: 'Select an ECU producer',
  })[this.faultyVehicleDataService.selectedField()]);

  ngOnInit() {
    this.faultyVehicleDataService.resetToDefault();
    this.searchChanges.pipe(debounceTime(250), takeUntilDestroyed(this.destroyRef))
        .subscribe(value => {
          if (value !== null && value !== this.faultyVehicleDataService.searchString()) {
            this.faultyVehicleDataService.searchFaultyData(value);
          }
        });
  }

  getFaultyValue(value: string) {
    this.selectedFaultyValue.set(value);
  }

  onSearchInput(value: string) {
    this.searchInput.set(value);
    this.searchChanges.next(value.trim());
  }

  onFieldChange(event: {value: VehicleDataFieldEnum}) {
    this.searchChanges.next(null);
    this.searchInput.set('');
    this.faultyVehicleDataService.changeSelectedField(event.value);
  }

  ngOnDestroy(): void { this.faultyVehicleDataService.cancel(); }

  getFieldLabel(field: VehicleDataFieldEnum): string {
    return this.fieldLabels[field];
  }
}
